/*global chrome*/

import { Box, Button, Link, Stack, Typography } from '@mui/material';
import React from 'react';
import { PrimaryBaseText, PrimaryNormalText, RegularSmallText } from '../../common/typography';
import LocalStorage from 'utils/extension/localstorage';
import { signOut } from 'utils/extension';

const Authorized = ({ onClick = () => {} }) => {
    return (
        <>
            <Box mt={2} display="flex" flexDirection="column" gap={2}>
                <Typography className="text-dark-blue font-roboto fw-500 font-base">Diolog would like to access your email.</Typography>
                <Stack gap={2} mt={1} px={1}>
                    <Typography className="text-dark-blue font-roboto">
                        By connecting your Diolog account to the Diolog email extension, you consent Diolog to:
                    </Typography>
                    <Typography>
                        <Typography className="text-dark-blue font-roboto fw-500">Access authorised company emails</Typography>
                        <Typography className="text-dark-blue font-roboto">
                            Allows Diolog’s email extension to access emails authorised by the administrators of Diolog company accounts
                            that your account is associated with.
                        </Typography>
                    </Typography>
                    <Typography>
                        <Typography className="text-dark-blue font-roboto fw-500">Read email subject lines and content</Typography>
                        <Typography className="text-dark-blue font-roboto">
                            Diolog will be able to read the emails of subject lines and email content.
                        </Typography>
                    </Typography>
                </Stack>
            </Box>
            <Box mt={2} display="flex" alignItems="center" width="100%" gap={2} justifyContent="center">
                <Box>
                    <Button
                        disableElevation
                        disableRipple
                        fullWidth
                        size="large"
                        type="submit"
                        className="alternate-reversed"
                        component={Link}
                        variant="outline-half"
                        onClick={onClick}
                    >
                        Cancel
                    </Button>
                </Box>
                <Box>
                    <Button
                        disableElevation
                        disableRipple
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                        className="alternate"
                        component={Link}
                        onClick={() => {
                            const selectedCompany = LocalStorage.getSelectedCompany();
                            const authToken = LocalStorage.getAuthToken();
                            const userData = LocalStorage.getUserData();
                            const isNotFromOrganization = LocalStorage.getUserType();
                            LocalStorage.remove(['diologExtEmail']);

                            window.parent.postMessage(
                                {
                                    type: 'SAVE_TO_LOCAL_STORAGE',
                                    data: {
                                        userData,
                                        selectedCompany,
                                        authToken,
                                        isNotFromOrganization
                                    }
                                },
                                '*'
                            );
                            signOut();
                        }}
                    >
                        Consent
                    </Button>
                </Box>
            </Box>
            <Stack gap={1} mt={2}>
                <Typography className="text-dark-blue font-roboto text-xs fw-500">Privacy is important to us.</Typography>
                <Typography className="font-roboto text-xs">
                    We respect your privacy. Rest assured, your email data is private and secure to your company account only. Diolog does
                    not have access to communication data in your company portal. See the{' '}
                    <Link
                        href="https://www.diolog.com.au/help/help-articles/privacy-policy"
                        sx={{
                            textDecoration: 'underline !important'
                        }}
                        underline="always"
                        target="_blank"
                        rel="noreferrer"
                        color="inherit"
                    >
                        Privacy Policy
                    </Link>{' '}
                    and{' '}
                    <Link
                        href="https://www.diolog.com.au/help/help-articles/customer-general-terms"
                        sx={{ textDecoration: 'underline !important' }}
                        underline="always"
                        target="_blank"
                        rel="noreferrer"
                        color="inherit"
                    >
                        Customer General Terms.
                    </Link>
                </Typography>
            </Stack>
        </>
    );
};

export default Authorized;
